module.exports = __webpack_public_path__ + "img/banner-2.1ccdf7d2.svg";